import SelectColTable from '@/components/SelectColTable.vue';
import FooterControl from '@/components/FooterControl.vue';
import { pageSizes } from '@/config/constant';

export default {
  name: 'home',
  components: { SelectColTable, FooterControl },
  data() {
    return {
      time: '', // 盘点时间
      purchaseAmount: '', // 零售盈亏合计
      prescriptionAmount: '', // 进货盈亏合计
      code: '', // 盘点单id
      remark: '', // 备注
      creator: '', // 制单人
      pageSizes,
      stocktaking: [], // 未盘点列表
      total: 0, // 总数据条数
      pageSize: 20, // 每页数据条数
      currentPage4: 1, // 页码 从1开始
      isLoading: false,
      id: this.$route.query.id || '',
      orderByInventory: '', // 排序
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    // 排序
    sortChange(column) {
      let sort = '';
      if (column.order === 'ascending') {
        sort = 'asc';
      } else if (column.order === 'descending') {
        sort = 'desc';
      }
      this.orderByInventory = `${column.prop} ${sort}`;
      this.currentPage = 1;
      this.getTableData();
    },
    // 返回
    goback() {
      this.$router.go(-1);
    },
    // 隐藏展开icon
    getRowClass({ row }) {
      // 即没有子元素时，添加row-expand-cover类,隐藏展开icon
      if (row.stocktakingDetailBatch && row.stocktakingDetailBatch.length < 2) {
        return 'row-expand-cover';
      }
      return '';
    },
    // 获取盘点列表信息
    getTableData() {
      this.$api.drugControl.getStocktaking({
        id: this.id,
      }).then((res) => {
        console.log(res);
        this.time = res.time || new Date(); // 盘点时间
        this.remark = res.remark || ''; // 备注
        this.purchaseAmount = res.purchaseAmount || ''; // 零售盈亏合计
        this.prescriptionAmount = res.prescriptionAmount || ''; // 进货盈亏合计
        this.code = res.code || ''; // 盘点单id
        this.creator = res.creator || ''; // 制单人
        this.alStocktaking();
      });
    },
    // 已盘点列表信息
    alStocktaking() {
      this.$api.drugControl.alStocktaking({
        stocktakingId: this.id,
        currentPage: this.currentPage4,
        pageSize: this.pageSize,
        orderByInventory: this.orderByInventory,
      }).then((res) => {
        console.log(res);
        this.stocktaking = res.stocktakingDetail;
        this.total = res.totalSize;
      });
    },
    // 每页展示数据条数变更
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.getTableData();
    },
    // 翻页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getTableData();
    },
    // 获取盈亏数量
    getNum(real, book) {
      let plNum = [];
      let realNum = 0;
      let bookNum = 0;
      let units = '';
      let dis = 0; // 商
      let num = 0;
      let remainder = 0; // 余数
      real.forEach((item) => {
        realNum += Number(item.num) * Number(item.ratio);
      });
      book.forEach((item) => {
        bookNum += Number(item.num) * Number(item.ratio);
      });
      num = Number(realNum) - Number(bookNum);
      if (num < 0) {
        units = '-';
      } else if (num > 0) {
        units = '+';
      }
      num = Math.abs(num);
      real.forEach((item, index) => {
        if (index === 0) {
          dis = parseInt(num / (item.ratio), 10);
          remainder = num % (item.ratio);
        } else {
          dis = parseInt(remainder / (item.ratio), 10);
          remainder %= item.ratio;
        }
        if (dis > 0) {
          plNum += `${dis}${item.unit}`;
        }
      });
      return `${units}${plNum}`;
    },
    // 导出
    fileExport() {
      this.$api.drugControl.inventoryExport({ id: this.id });
    },
  },
};
